window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    
  const sections = gsap.utils.toArray(".klima-anim-section_text");

  sections.forEach((section) => {
    const primaryText = section.querySelector(".klima-anim-text_primary");
    const secondaryText = section.querySelectorAll(
      ".klima-anim-text_secondary"
    );
    const pill = section.querySelector(".klima-pill_anim");
    const staggerOnDesktop = section.classList.contains(
      "klima-anim-section_text_staggered"
    );

    // split primary text words into separate spans for staggered animation
    let headerWordSpans;
    if (primaryText) {
      const headerWords = primaryText.innerHTML.split(" ");
      primaryText.innerHTML = headerWords
        .map((word) => {
          return `<span>${word} </span>`;
        })
        .join("");

      headerWordSpans = primaryText.querySelectorAll("span");
    }

    let tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: "top 20%", end: "bottom 40%" },
      delay: staggerOnDesktop ? 0.1 : 0,
    });
    let mm = gsap.matchMedia();
    mm.add("(max-width: 767px)", () => {
      tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 50%",
          end: "bottom 40%",
        },
      });
    });
    {
      pill &&
        tl.fromTo(
          pill,
          { y: 16, opacity: 0 },
          {
            duration: 0.4,
            opacity: 1,
            y: 0,
            ease: "power3.out",
          }
        );
    }
    {
      headerWordSpans &&
        tl.fromTo(
          headerWordSpans,
          { clipPath: "inset(100% 0% 0% 0%)" },
          {
            duration: 0.6,
            clipPath: "inset(0% 0% 0% 0%)",
            ease: "power3.out",
            stagger: 0.05,
          },
          "<"
        );
    }
    tl.fromTo(
      secondaryText,
      { y: 50, opacity: 0 },
      {
        duration: 0.5,
        opacity: 1,
        y: 0,
        ease: "power3.out",
        stagger: 0.2,
      },
      "<0.2"
    );
  });
  }, 500)
    
});
